import script from "./Pla06TabPage.vue?vue&type=script&setup=true&lang=js"
export * from "./Pla06TabPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__